import { useContext } from 'react';
import ManualQuoteStore from '../stores/manualQuoteStore';
import { StoreContext } from '@roc/feature-app-core';


export const useManualQuoteStore = () => useContext<{
  manualQuoteStore: ManualQuoteStore
}>(StoreContext);
